import React from 'react'
import { SocialIcon as ReactSocialIcons } from 'react-social-icons'
import styled from 'styled-components'

const StyledSocialLink = styled.div`
  display: flex;
  align-self: flex-end;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
`

const StyledReactSocialIcons = styled(ReactSocialIcons)`
  height: ${(props) => props.height} !important;
  width: ${(props) => props.height} !important;
`

const SocialIcon = ({ url, network, ...props }) => (
  <StyledSocialLink {...props}>
    <StyledReactSocialIcons
      {...props}
      network={network}
      bgColor="#424449"
      url={url}
      target="_blank"
      rel="nofollow noopener"
    />
  </StyledSocialLink>
)

export default SocialIcon
